<template>
  <div>
    <div class="container py-0 fill-height">
      <v-spacer /><v-btn>sdsd</v-btn>
      <!-- 
      <button
        type="button"
        class="v-btn v-btn--text theme--light v-size--default"
      >
   <span class="v-btn__content" v-if="!watchuser"
          ><router-link to="/">
            <a class="smallcaps">Home</a>
          </router-link>
        </span>

        <span class="v-btn__content" v-if="watchuser"
          ><router-link to="/vertragsschutz">
            <a class="smallcaps">Home</a>
          </router-link>
        </span>
      </button>
      |
      <span v-if="!watchuser">
        <button
          type="button"
          class="v-btn v-btn--text theme--light v-size--default"
        >
          <span class="v-btn__content"
            ><a class="smallcaps" href="/info/vertragscheck">VertragsCheck</a>
          </span>
        </button>

        |
        <button
          type="button"
          class="v-btn v-btn--text theme--light v-size--default"
        >
          <span class="v-btn__content"
            ><a class="smallcaps" href="/info/anspruchspruefung"
              >Anspruchsprüfung</a
            >
          </span>
        </button>

        |
        <button
          type="button"
          class="v-btn v-btn--text theme--light v-size--default"
        >
          <span class="v-btn__content"
            ><a class="smallcaps" href="/info/impressum">Impressum</a>
          </span>
        </button>
      </span>
      <span v-if="watchuser">
        <button
          type="button"
          class="v-btn v-btn--text theme--light v-size--default"
        >
          <span class="v-btn__content">
            <router-link to="/vertragsschutz">
              <a class="smallcaps">Mein Vertragsschutz</a></router-link
            >
          </span>
        </button>
        |
        <button
          type="button"
          class="v-btn v-btn--text theme--light v-size--default"
        >
          <span class="v-btn__content">
            <router-link to="/rechnung">
              <a class="smallcaps">Rechnung einreichen</a>
            </router-link>
          </span>
        </button>
        |
        <button
          type="button"
          class="v-btn v-btn--text theme--light v-size--default"
        >
          <span class="v-btn__content">
            <router-link to="/pruefung">
              <a class="smallcaps">Anspruch prüfen lassen</a>
            </router-link>
          </span>
        </button>
      </span> -->
      <div class="spacer"></div>
      <div class="v-responsive" style="max-width: 260px">
        <v-btn
          @click="showLogin = !showLogin"
          width="100"
          v-if="!watchuser"
          tile
          outlined
          color="grey"
          class="button_caps"
        >
          <v-icon class="green--text" left>mdi-lock</v-icon>
          <a class="grey--text" @click="showLogin != showLogin">Login</a>
        </v-btn>

        <v-btn
          @click="startLogout()"
          width="100"
          v-if="watchuser"
          tile
          outlined
          color="grey"
          class="button_caps"
        >
          <v-icon class="red--text" left>mdi-logout</v-icon>
          <a class="grey--text">Logout</a>
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="showLogin" max-width="800">
      <v-card class="pa-4"> <index-login /></v-card>
    </v-dialog>
  </div>
</template>

<script>
  import IndexLogin from "./IndexLogin.vue";
  import { mapState, mapMutations } from "vuex";

  export default {
    name: "AppBar",
    props: [],
    components: { IndexLogin },
    data: function() {
      return {
        showLogin: false,
      };
    },
    created() {},
    methods: {
      ...mapMutations("nav", [
        "showDrawer",
        "hideDrawer",
        "minimizeDrawer",
        "maximizeDrawer",
      ]),
      startLogout() {
        // this.$store.commit("user", false);
        this.$store.dispatch("startLogout").then((resp) => {
          if (resp.data.success) {
            this.$store.commit("user", false);
            this.$router.push("/");
          }

          //
        });
      },
    },
    computed: {
      watchuser() {
        return this.$store.getters.getUserStore;
      },
      ...mapState("nav", ["drawerVisible", "miniVariant"]),
    },
  };
</script>
<style></style>
